__turbopack_context__.v({
  "desktopButton": "iVNniW_desktopButton",
  "mobileButton": "iVNniW_mobileButton",
});
